import type { PropsWithChildren } from 'react';
import { Grid, Button, GridItem } from '@flos/react-ui';
import ActionRow from './ActionRow';
import { useHippoText } from '../../../hooks/useHippoText';

const AccordionWizardTemplate = ({
    children,
    disableNext = false,
    goNext,
    continueButtonText = '',
    isNextBtnLoading = false
}: PropsWithChildren<{
    disableNext?: boolean;
    goNext: () => void;
    continueButtonText?: string;
    isNextBtnLoading?: boolean;
}>): React.JSX.Element => {
    const getHippoText = useHippoText();

    return (
        <Grid>
            <GridItem span={12}>
                <>{children}</>
            </GridItem>
            <GridItem span={12}>
                <br />
                <ActionRow>
                    <Button
                        id="checkout-page-next-button-accordion"
                        onClick={goNext}
                        disabled={disableNext || isNextBtnLoading}
                        isLoading={isNextBtnLoading}
                        loadingText={getHippoText('DSS-COMMON-BUTTON-WAIT')}
                    >
                        {continueButtonText || getHippoText('DSS-COMMON-CONTINUE')}
                    </Button>
                </ActionRow>
            </GridItem>
        </Grid>
    );
};

export default AccordionWizardTemplate;
